module.exports = __webpack_public_path__ + "img/62.6d90eecd.png";